import LayoutCustomerMain from "components/layout/LayoutCustomerMain";
import QuontationStatus1 from "./QuontationStatus1";
import Css from 'components/pages/customer/Customer.module.css';
import { useEffect, useState } from "react";
import ApiConection from 'api_ref/ApiConection';
import ProfileUser from "./ProfileUser";
import { ToastError, ToastSuccess } from 'components/MyControl';
import UtilClass from "api_ref/UtilClass";

export default function CustomerProfileUser() {
    const api = new ApiConection();
    const util = new UtilClass();

    const registerSession = util.getSessionStorage('register');

    const [user, setUser] = useState(undefined);
    const [alert, setAlert] = useState('');
    const [showToastSuccess, setShowToastSuccess] = useState(false);
    const [showToastError, setShowToastError] = useState(false);

    const getData = async () => {
        const response = await api.getData(`api/customerprofile/${registerSession.user_id}/register/${registerSession.register_number}/user`)

        if (response.status === true) {
            setUser(response.data);
        }
    }

    const setData = async (Childdata) => {
        let request = {
            first_name: Childdata.first_name,
            last_name: Childdata.last_name,
            tel: Childdata.tel
        }
        const response = await api.putData(`api/customerprofile/${registerSession.user_id}/register/${registerSession.register_number}/user`, request)

        if (response.status === false) {
            setAlert(response.message);
            setShowToastError(true);
        } else {
            setAlert('');
            await getData();
            setShowToastSuccess(true);
        }
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <LayoutCustomerMain role="customer" >
            <QuontationStatus1 />
            <div className={Css.Block_Transparent}><br />
                <h5 className={Css.color1}>ข้อมูลส่วนตัว</h5><br />
                <div className={Css.Graph_Group}>
                    {user != undefined &&
                        <ProfileUser
                            data={user}
                            callSubmitParentData={setData}
                            parentAlert={alert} />}
                </div>
            </div>
            <ToastSuccess show={showToastSuccess} closeFc={setShowToastSuccess} message='ระบบได้บันทึกข้อมูลแล้ว' />
            <ToastError show={showToastError} closeFc={setShowToastError} message={'เกิดข้อผิดพลาด!!'} />
        </LayoutCustomerMain>
    )
}